let viewgird = [
  //
  // ----------
  // 系统相关
  {
    path: '/setting',
    name: 'setting',
    component: () => import('@/views/sys/setting.vue')
  },
  {
    path: '/Sys_WebConfig',
    name: 'Sys_WebConfig',
    component: () => import('@/views/sys/sys/Sys_WebConfig.vue')
  },
  {
    path: '/Sys_Log',
    name: 'sys_Log',
    component: () => import('@/views/system/Sys_Log.vue')
  },
  {
    path: '/Sys_User',
    name: 'Sys_User',
    component: () => import('@/views/system/Sys_User.vue')
  },
  {
    path: '/permission',
    name: 'permission',
    component: () => import('@/views/system/Permission.vue')
  },

  {
    path: '/Sys_Dictionary',
    name: 'Sys_Dictionary',
    component: () => import('@/views/system/Sys_Dictionary.vue')
  },
  {
    path: '/Sys_Role',
    name: 'Sys_Role',
    component: () => import('@/views/system/Sys_Role.vue')
  },
  {
    path: '/Sys_Role1',
    name: 'Sys_Role1',
    component: () => import('@/views/system/Sys_Role1.vue')
  },
  {
    path: '/Sys_DictionaryList',
    name: 'Sys_DictionaryList',
    component: () => import('@/views/system/Sys_DictionaryList.vue')
  },
  {
    path: '/Sys_WorkFlow',
    name: 'Sys_WorkFlow',
    component: () => import('@/views/system/flow/Sys_WorkFlow.vue')
  },
  {
    path: '/Sys_WorkFlowTable',
    name: 'Sys_WorkFlowTable',
    component: () => import('@/views/system/flow/Sys_WorkFlowTable.vue')
  },
  {
    path: '/Sys_QuartzOptions',
    name: 'Sys_QuartzOptions',
    component: () => import('@/views/system/quartz/Sys_QuartzOptions.vue')
  },
  {
    path: '/Sys_QuartzLog',
    name: 'Sys_QuartzLog',
    component: () => import('@/views/system/quartz/Sys_QuartzLog.vue')
  },
  {
    path: '/FormDesignOptions',
    name: 'FormDesignOptions',
    component: () => import('@/views/system/form/FormDesignOptions.vue')
  },
  {
    path: '/FormCollectionObject',
    name: 'FormCollectionObject',
    component: () => import('@/views/system/form/FormCollectionObject.vue')
  },
  {
    path: '/Sys_Department',
    name: 'Sys_Department',
    component: () => import('@/views/system/system/Sys_Department.vue')
  },
  {
    path: '/Sys_Tenant',
    name: 'Sys_Tenant',
    component: () => import('@/views/sys/system/Sys_Tenant.vue')
  },
  {
    path: '/Sys_DbService',
    name: 'Sys_DbService',
    component: () => import('@/views/sys/system/Sys_DbService.vue')
  },
  {
    path: '/Sys_File_Info',
    name: 'Sys_File_Info',
    component: () => import('@/views/sys/sys_file/Sys_File_Info.vue')
  },
  {
    path: '/Sys_File_Category',
    name: 'Sys_File_Category',
    component: () => import('@/views/sys/sys_file/Sys_File_Category.vue')
  },
  {
    path: '/Sys_File_Version',
    name: 'Sys_File_Version',
    component: () => import('@/views/sys/sys_file/Sys_File_Version.vue')
  },
  {
    path: '/Sys_File_OperLog',
    name: 'Sys_File_OperLog',
    component: () => import('@/views/sys/sys_file/Sys_File_OperLog.vue')
  },
  {
    path: '/Sys_File_Recycle',
    name: 'Sys_File_Recycle',
    component: () => import('@/views/sys/sys_file/Sys_File_Recycle.vue')
  },
  {
    path: '/Sys_Config',
    name: 'Sys_Config',
    component: () => import('@/views/sys/sys/Sys_Config.vue')
  },
  //
  // ----------
  // 消息管理
  {
    path: '/Dev_Message',
    name: 'Dev_Message',
    component: () => import('@/views/system/message/Dev_Message.vue')
  },
  {
    path: '/Dev_MessageGroup',
    name: 'Dev_MessageGroup',
    component: () => import('@/views/device/message/Dev_MessageGroup.vue')
  },
  {
    path: '/Dev_MessageGroupUser',
    name: 'Dev_MessageGroupUser',
    component: () => import('@/views/device/message/Dev_MessageGroupUser.vue')
  },
  {
    path: '/Dev_MessageLog',
    name: 'Dev_MessageLog',
    component: () => import('@/views/device/message/Dev_MessageLog.vue')
  },
  {
    path: '/MetMessage',
    name: 'MetMessage',
    component: () => import('@/views/method/message/MetMessage.vue')
  },
  {
    path: '/MetMessageGroup',
    name: 'MetMessageGroup',
    component: () => import('@/views/method/message/MetMessageGroup.vue')
  },
  {
    path: '/MetMessageGroupUser',
    name: 'MetMessageGroupUser',
    component: () => import('@/views/method/message/MetMessageGroupUser.vue')
  },
  {
    path: '/MetMessageLog',
    name: 'MetMessageLog',
    component: () => import('@/views/method/message/MetMessageLog.vue')
  }
];

export default viewgird;
